import React from 'react'

const frames = {
  map:
    '<iframe src="https://www.google.com/maps/d/u/0/viewer?hl=ru&mid=1G-rB1wMqJtTngGH13H09CITH5FBTScw&ll=59.937404700000016%2C30.282176200000013&z=11" width="100%" height="100%" style="border:0;" allowFullScreen="true" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>',
  mapY:
    '<iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3Aa4f8f4de48ea385de92d1ae65fcf1f39e8086e183b4bc783e3f628854821249a&amp;source=constructor" width="100%" height="100%" frameborder="0"></iframe>'
}

const Iframe = (props) => {
  return (
    <div className="mapWrapper" dangerouslySetInnerHTML={{ __html: props.iframe ? props.iframe : ""}} />
  )
}
const MapsPage = () => {
  return (
    <section className="orderList closeFilter">
      <div className="pageContent closeFilter">
        <Iframe iframe={frames["mapY"]} />
      </div>
    </section>
  )
}

export default MapsPage
